/*
 * @Author: scg
 * @Date: 2022-03-02 10:38:35
 * @LastEditTime: 2022-03-03 13:50:32
 * @LastEditors: scg
 * @Description:
 */
import config from '@/config'
export function getUrlBase64 (url) {
  return new Promise(resolve => {
    // let canvas = document.createElement('canvas')
    // let ctx = canvas.getContext('2d')
    // let img = new Image()
    // img.crossOrigin = 'Anonymous' // 允许跨域
    // img.src = config.baseURL + 'index/index/download?url=' + url
    resolve(config.fileURL + 'index/index/download?url=' + url)
    // img.onload = function () {
    //   canvas.height = 300
    //   canvas.width = 300
    //   ctx.drawImage(img, 0, 0, 300, 300)
    //   let dataURL = canvas.toDataURL('image/png')
    //   canvas = null
    //   resolve(dataURL)
    // }
  })
}
// 下载
export function downloadFilePic (url) {
  url = url.replace(/\\/g, '/')
  const xhr = new XMLHttpRequest()
  xhr.open('GET', url, true)
  xhr.responseType = 'blob'
  xhr.onload = () => {
    if (xhr.status === 200) {
      // 获取文件blob数据并保存
      var num = url.lastIndexOf('/') + 1
      // 把参数和文件名分割开
      var fileName = url.substring(num).split('?')[0]
      var export_blob = new Blob([xhr.response])
      var save_link = document.createElementNS(
        'http://www.w3.org/1999/xhtml',
        'a'
      )
      save_link.href = URL.createObjectURL(export_blob)
      save_link.target = '_blank'
      save_link.download = fileName
      save_link.click()
    }
  }
  xhr.send()
}



// WEBPACK FOOTER //
// ./src/api/getUrlBase64.js